var React = require('react');

function SDocument22 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#707070","transform":"translate(3 2)"},[React.createElement("path",{"d":"M8,6.5 L8,1 L1.5,1 C1.36502447,0.991724489 1.23298229,1.04173962 1.13736095,1.13736095 C1.04173962,1.23298229 0.991724489,1.36502447 1,1.5 L1,16.5 C0.991724489,16.6349755 1.04173962,16.7670177 1.13736095,16.862639 C1.23298229,16.9582604 1.36502447,17.0082755 1.5,17 L13.5,17 C13.6349755,17.0082755 13.7670177,16.9582604 13.862639,16.862639 C13.9582604,16.7670177 14.0082755,16.6349755 14,16.5 L14,7 L8.5,7 C8.36502447,7.00827551 8.23298229,6.95826038 8.13736095,6.86263905 C8.04173962,6.76701771 7.99172449,6.63497553 8,6.5 Z","key":0}),React.createElement("path",{"d":"M9.5,1 C9.7,1 9.81451613,1 9.9,1.1 L13.9,5.1 C14,5.2 14,5.3 14,5.5 L9.5,5.5 L9.5,1 Z","key":1})]));
}

SDocument22.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = SDocument22;

SDocument22.default = SDocument22;
